import { storyblokEditable } from "@storyblok/react/rsc";
import { SbBlokData } from "@storyblok/react";

export function Fallback({ blok }: { blok: SbBlokData }) {
  return (
    <h2 data-cy="fallback" {...storyblokEditable(blok)}>
      This component does not exists: {blok.component}
    </h2>
  );
}
